// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-icon {\n  max-width: 100px;\n  margin-right: 10px;\n}", ""]);
// Exports
module.exports = exports;
